export const corianderGreen = '#27ae60';
export const pomegranateRed = '#e74c3c';
export const whisperGray = '#e7e7e7';
